import type { TransitionConfig } from 'svelte/transition'

function easeInOutBack(t: number): number {
	const c1 = 1.70158
	const c2 = c1 * 1.525
	return t < 0.5
		? (Math.pow(2 * t, 2) * ((c2 + 1) * 2 * t - c2)) / 2
		: (Math.pow(2 * t - 2, 2) * ((c2 + 1) * (t * 2 - 2) + c2) + 2) / 2
}

export function scaleFadeFromTopRight(node: Element, { duration = 500 } = {}): TransitionConfig {
	// Set transform-origin for scaling from top right
	;(node as HTMLElement).style.transformOrigin = 'top right'

	return {
		duration,
		easing: easeInOutBack,
		css: (t: number) => {
			// t: 0 (start) -> t: 1 (end)
			// scale: 0.96 -> 1
			// opacity: 0 -> 1
			const scale = 0.96 + 0.04 * t
			const opacity = t
			return `
			opacity: ${opacity};
			transform: scale(${scale});
		 `
		}
	}
}
